<template>
  <QuestionBase
      :question="question"
      :valid="!!(valueFirst || valueSecond)"
      :errors="errors"
  >
    <div class="question-multipart-wrapper d-flex flex-wrap align-items-end">
      <div class="question question-multipart field-50">
        <InputBasic
            :value="valueFirst"
            @input="$emit('inputFirst', $event)"
            ref="email"
            :args="firstInputOptions"
            :db="db.first"
            :skipped="skipped"
            :no-save="noSave"
            :errorsPost="errorsPostEmail"
            @skipped="skipped=$event"
            @serverErrors="serverErrors.email=$event"
            @jsErrors="jsErrors=$event"
        />

      </div>
      <div class="question question-multipart field-50">
        <InputBasic
            :value="valueSecond"
            @input="$emit('inputSecond', $event)"
            ref="phone_number"
            :args="secondInputOptions"
            :db="db.second"
            :skipped="skipped"
            :no-save="noSave"
            :errorsPost="errorsPostPhoneNumber"
            @skipped="skipped=$event"
            @serverErrors="serverErrors.phone_number=$event"
            @jsErrors="jsErrors=$event"
        />
      </div>
    </div>
  </QuestionBase>
</template>

<script>
import {skipHelpers} from "../helpers/skipHelpers";
import {questionLoadHelpers} from "../../helpers/questionLoadHelpers";

import QuestionBase from "../../QuestionBase";
import InputBasic from "../../inputs/InputBasic";

export default {
  name: 'ContactInformation',
  components: {
    InputBasic,
    QuestionBase
  },
  mixins: [skipHelpers, questionLoadHelpers],
  props: {
    valueFirst: {
      type: String,
      required: false
    },
    valueSecond: {
      type: String,
      required: false
    },
    objectId: {
      type: [Number, String],
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    errorsPostPhoneNumber: {
      type: Array,
      default: () => {
        return []
      }
    },
    errorsPostEmail: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  computed: {
    errors() {
      return [...this.errorsPostPhoneNumber, ...this.errorsPostEmail, ...this.jsErrors]
    }
  },
  data() {
    return {
      question: {
        title: 'Email address and/or mobile number?',
        subTitle: 'We do not store this information for marketing purposes. We send a single communication with details of the referral scheme and how to book an appointment.',
        tip: null
      },
      firstInputOptions: {
        placeholder: 'e.g. example@example.com',
        label: 'Email:',
        type: 'text',
      },
      secondInputOptions: {
        placeholder: 'e.g. 0797238715',
        label: 'Phone Number:',
        type: 'text',
      },
      db: {
        saveLocation: 'referral_save',
        saveField: 'email',
        first: {
          saveLocation: 'referral_save',
          saveField: 'email',
          objectId: this.objectId
        },
        second: {
          saveLocation: 'referral_save',
          saveField: 'phone_number',
          objectId: this.objectId
        },
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: {
        email: [],
        phone_number: [],
      },
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
